const ErrorHandler = {
  install(Vue) {
    Vue.prototype.getErrorMessage = ({
      body: { description = '', error_message: errorMessage = '', message = '' } = {},
      status,
    }) => {
      if (errorMessage) return errorMessage
      if (message) return message
      if (description) return description

      switch (status) {
        case 401: {
          return 'Unauthorized.'
        }
        case 403: {
          return 'Access denied.'
        }
        case 404: {
          return 'The desired resource cannot be found.'
        }
        case 500: {
          return 'Sorry, the service is temporarily unavailable.'
        }
        default: {
          if (status > 500) {
            return 'Sorry, something went wrong. Please try again later.'
          }
          if (status >= 400) {
            return 'Bad request.'
          }
          return 'Sorry, something went wrong. Please try again later.'
        }
      }
    }
  },
}

export default ErrorHandler



// WEBPACK FOOTER //
// ./src/utils/error-handler.js